import type { SVGProps } from 'react';
const SvgStars03 = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={14} viewBox="0 0 14 14" width={14} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.792 4.666V1.749m-7.583 10.5V9.333m6.125-6.125h2.916M1.75 10.79h2.917m-.875-9.625-.458.915c-.154.31-.232.465-.335.599a1.8 1.8 0 0 1-.318.318c-.134.103-.29.18-.599.335l-.915.458.915.458c.31.154.465.232.599.335q.18.139.318.318c.103.134.18.29.335.599l.458.915.458-.915c.154-.31.232-.465.335-.599a1.8 1.8 0 0 1 .318-.318c.134-.103.29-.18.599-.335l.915-.458-.915-.458c-.31-.154-.465-.232-.599-.335a1.8 1.8 0 0 1-.318-.318c-.103-.134-.18-.29-.335-.599zm6.125 5.833-.555 1.11c-.155.31-.232.465-.336.599a1.8 1.8 0 0 1-.317.317c-.134.104-.29.181-.599.336L7 9.916l1.11.555c.31.155.465.232.599.336q.18.138.317.317c.104.134.181.29.336.599l.555 1.11.555-1.11c.155-.31.232-.465.336-.599q.137-.18.317-.317c.134-.104.29-.181.599-.336l1.11-.555-1.11-.555c-.31-.155-.465-.232-.599-.336a1.8 1.8 0 0 1-.317-.317c-.104-.134-.181-.29-.336-.599z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.33}
    />
  </svg>
);
export default SvgStars03;
export { SvgStars03 };
